import { PaginationConfig } from '@common/store/member-slice';

export const getActivePage = (config: PaginationConfig): number => {
  const newOffset = config.currentFilter.offset || 0;
  const activePage = newOffset / config.pageSize + 1;

  return activePage;
};
